var map = {
	"./photo1.JPG": 403,
	"./photo1.jpeg": 779,
	"./photo2.JPG": 180,
	"./photo3.JPG": 25,
	"./photo4.JPG": 698,
	"./photo5.JPG": 519,
	"./photo6.JPG": 768,
	"./photo7.JPG": 893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 496;